var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"app-top-warning d-flex align-center justify-center text-white mb-0 px-4 pt-3 pb-2 fs-14 bg-glass"},[_c('span',{staticClass:"text-white fs-14",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }